export default __webpack_public_path__ + "static/media/cases2.621884f5.jpg";